import * as XLSX from '@e965/xlsx';
import type { Location } from '../types';

/**
 * Strip HTML tags from a string
 */
function stripHtml(html: string): string {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
}

/**
 * Export locations to Excel format using SheetJS
 */
export function exportLocationsToExcel(locations: Location[], filename?: string): void {
  const headers = [
    'Name',
    'Room Number',
    'Site',
    'Account',
    'Phone',
    'Extension',
    'Fax',
    'User Group',
    'Tags',
    'Description',
    'Latitude',
    'Longitude',
    'Disabled',
    'Created At',
  ];

  const rows = locations.map((location) => [
    location.name || '',
    location.roomNumber || '',
    location.siteName || '',
    location.accountName || '',
    location.phone || '',
    location.extension || '',
    location.fax || '',
    location.usergroupName || '',
    (location.tags || []).join('; '),
    stripHtml(location.description || ''),
    location.latitude ?? '',
    location.longitude ?? '',
    location.disabled ? 'Yes' : 'No',
    location.createdAt ? new Date(location.createdAt).toLocaleDateString() : '',
  ]);

  const data = [headers, ...rows];
  const ws = XLSX.utils.aoa_to_sheet(data);

  // Set column widths
  ws['!cols'] = [
    { wch: 25 }, // Name
    { wch: 12 }, // Room Number
    { wch: 20 }, // Site
    { wch: 20 }, // Account
    { wch: 15 }, // Phone
    { wch: 8 },  // Extension
    { wch: 15 }, // Fax
    { wch: 18 }, // User Group
    { wch: 25 }, // Tags
    { wch: 30 }, // Description
    { wch: 12 }, // Latitude
    { wch: 12 }, // Longitude
    { wch: 8 },  // Disabled
    { wch: 12 }, // Created At
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Locations');

  const exportFilename = filename || `locations-export-${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(wb, exportFilename);
}
